module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-5ff6a651.png";